import {
  CategoryResponse,
  DayExperienceResponse,
  IslandResponse
} from "./api/DayExperienceResponse";

export class DayExperience {
  name: string;
  location: string[];
  description: string;
  category: string[];
  price: string;
  img: string;
  permalink: string;

  constructor(resp?: DayExperienceResponse) {
    this.name = resp?.name ?? "";
    this.location = resp?.islands ?? [];
    this.description = resp?.subtitle ?? "";
    this.category = resp?.categories ?? [];
    this.price = resp?.price ?? "";
    this.img = resp?.image ?? "";
    this.permalink = resp?.permalink ?? "";
  }
}

export class Island {
  label: string;
  value: string;

  constructor(resp?: IslandResponse) {
    this.label = resp?.name ?? "";
    this.value = resp?.name ?? "";
  }
}

export class Category {
  label: string;
  value: string;

  constructor(resp?: CategoryResponse) {
    this.label = resp?.name ?? "";
    this.value = resp?.name ?? "";
  }
}
